"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      infoList: [{
        label: "课程名称",
        value: "xx作品"
      }, {
        label: "所属组别",
        value: "高职组"
      }, {
        label: "课程名称",
        value: "xx作品"
      }, {
        label: "所属组别",
        value: "高职组"
      }, {
        label: "课程名称",
        value: "xx作品"
      }, {
        label: "所属组别",
        value: "高职组"
      }],
      entryList: [{
        label: "片段节选",
        type: "video",
        src: "",
        url: ""
      }, {
        label: "封面",
        type: "img",
        src: "",
        url: ""
      }, {
        label: "封面",
        type: "img",
        src: "",
        url: ""
      }]
    };
  },
  methods: {
    downLoadWorks: function downLoadWorks(e) {
      window.open(e);
    }
  }
};